export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11258.ea2dc8f9.jpg";